@if (cardDetails) {
  <app-block-card
    [cardDetails]="cardDetails"
    [cardType]="cardType"
    title="Block subscription card">
    <ng-container blockCardHeading>
      <div class="h4 mb-3">Are you sure you want to block "{{ cardDetails.name }}" subscription card?</div>
    </ng-container>
  </app-block-card>
}
